import { processSteps } from '../content';

export function Process() {
  return (
    <section className="process section-shell" id="process">
      <div className="process__layout">
        <header className="process__header reveal"><span className="section-kicker">How we get there</span><h2>Understand first. Build second.</h2><p>The software comes after the operation is understood.</p></header>
        <ol className="process-path reveal">
          {processSteps.map((step) => <li className="process-stage" key={step.number}><span>{step.number}</span><div><h3>{step.title}</h3><p>{step.description}</p></div></li>)}
        </ol>
      </div>
      <div className="approach-note reveal">
        <span>One builder. Full system context.</span>
        <p>I design, build, integrate, deploy, and operate the software—with a private multi-agent operations system supporting the work behind the scenes.</p>
      </div>
    </section>
  );
}
